export const snsProviderConst = ["google", "naver", "kakao"];
export const rolesProviderConst = ["user", "biz"];
export const dataLocalKeyProviderConst = {
  accessToken: {
    key: "aUofRg9QiOn7Qy",
  },
  email: {
    key: "erBywKWdaYOGSRA",
    password: "email_holy_moly",
  },
  page: {
    key: "p1bC3dE4fG5hIj",
    password: "login_before_page",
  },
  sns: {
    key: "sfgjrDdfaisas",
    password: "current_sns_login",
  },
  role: {
    key: "rdfoledfaswe",
    password: "my_role_user_biz",
  },
  nickname: {
    key: "nckaLsd3k21l",
    password: "my_nickname_pwd",
  },
};
